module.exports = __webpack_public_path__ + "static/media/golf.0cbe5c4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero-backgrounds/golf.jpg
// module id = 690
// module chunks = 0